
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sql-templates/[id]/[slug]",
      function () {
        return require("private-next-pages/sql-templates/[id]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sql-templates/[id]/[slug]"])
      });
    }
  